import React from 'react';
import { ImageProps } from '.';

const SvgFastshipSimpleKor = ({ size = 53, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 3.3125)) || 16} fill='none' viewBox='0 0 53 16' {...props}>
      <g fill='#3D4F6F' clipPath='url(#FastshipSimpleKor_svg__a)'>
        <path d='M36.93 6.035h1.504v1.74H36.93v7.677h-2.06V.522h2.06v5.513ZM42.849 13.517h8.484v1.673H40.755v-4.102h2.093v2.429ZM17.176 3.14c.388 0 .717.196.887.523l2.346 4.528a.83.83 0 0 1 .05.635l-.928 2.744a.626.626 0 0 1-.618.43h-1.576c-.08 0-.15.047-.17.122-.599 1.605-2.096 2.735-3.392 2.735-1.297 0-2.005-1.055-1.606-2.586.04-.15-.06-.271-.22-.271H7.857c-.08 0-.15.048-.17.122-.598 1.606-2.096 2.735-3.393 2.735-1.296 0-2.004-1.055-1.606-2.586.04-.15-.059-.27-.219-.271H1.413c-.329 0-.53-.251-.43-.55l.669-2.008c.09-.27.329-.43.618-.43h8.65c.46 0 .838-.251.978-.672l1.606-4.77a.625.625 0 0 1 .619-.43h3.053Z' />
        <path
          fillRule='evenodd'
          d='M26.417 5.33h.949V1.867h1.7v10.139h-4.365V1.868h1.716V5.33Zm0 4.955h.949V6.987h-.95v3.298ZM31.355 5.33h.964V1.867h1.7v10.139H29.67V1.868h1.685V5.33Zm0 4.955h.964V6.987h-.964v3.298Z'
          clipRule='evenodd'
        />
        <path d='M52.658 10.268H39.039V8.595h13.619v1.673ZM51.006 4.986h-8.19V6.05h8.468v1.575H40.74V3.492h8.174V2.475h-8.207V.867h10.3v4.119ZM10.832 5.064c.329 0 .53.252.43.551l-.51 1.512c-.09.271-.33.429-.619.429H.455c-.329 0-.53-.251-.43-.55l.51-1.513c.09-.27.329-.43.619-.43h9.678ZM12.149 1.143c.328 0 .528.251.428.55l-.508 1.513c-.09.271-.33.429-.619.43H5.463c-.328-.001-.528-.252-.428-.551l.51-1.512c.09-.271.328-.43.618-.43h5.986Z' />
      </g>
      <defs>
        <clipPath id='FastshipSimpleKor_svg__a'>
          <path fill='#fff' d='M0 0h53v16H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgFastshipSimpleKor;
